var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrganizationInactive = function SvgOrganizationInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "M9 6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V6ZM14 16a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2ZM4 16a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "M8 12.5a.5.5 0 0 0-.5.5v1h-1v-1A1.5 1.5 0 0 1 8 11.5h8a1.5 1.5 0 0 1 1.5 1.5v1h-1v-1a.5.5 0 0 0-.5-.5H8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "M12.5 10v2h-1v-2h1Z"
  })));
};
export default SvgOrganizationInactive;